import { setLoading, setGlobalMessage } from '../app';
import { ALERT_SEVERITY, ERROR_MESSAGES } from 'eebac/constants';
import { Catch } from '../api_exception';

const BASE_PATH = 'VENDOR_WORK_RATES';

export const SET_INFO_DATA = `${BASE_PATH}/SET_INFO_DATA`;
export const SET_RATE_INFO_DATA = `${BASE_PATH}/SET_RATE_INFO_DATA`;
export const CLEAR_INFO_DATA = `${BASE_PATH}/CLEAR_INFO_DATA`;
export const VALIDATE_INFO_DATA = `${BASE_PATH}/VALIDATE_INFO_DATA`;
export const SET_VALIDATE = `${BASE_PATH}/SET_VALIDATE`;
export const IS_VALID = `${BASE_PATH}/IS_VALID`;
export const SET_FORM_SUBMIT = `${BASE_PATH}/SET_FORM_SUBMIT`;
export const SET_SERVER_RATES_DATA = `${BASE_PATH}/SET_SERVER_RATES_DATA`;


export const updateWorkAndRates = () =>
    (dispatch, getState, client) => {

        let state = getState();

        dispatch(setLoading(true));
        let apiData = {};
        apiData.specilizationIn = state.VENDOR_WORK_RATES.specilizationIn &&
            Array.isArray(state.VENDOR_WORK_RATES.specilizationIn) &&
            state.VENDOR_WORK_RATES.specilizationIn.length > 0 ?
            state.VENDOR_WORK_RATES.specilizationIn : null;

        apiData.workRates = state.VENDOR_WORK_RATES.workRates ?
            state.VENDOR_WORK_RATES.workRates : null;

        client.put('/vendor/work_rates', apiData)
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const loadWorkAndRates = () =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        client.get('/vendor/work_rates')
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess && result.data.rates) {
                    dispatch(setServerWorkData(result.data.rates));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const validateData = () =>
    (dispatch, getState, client) => {
        dispatch(validateWorkRatesInfoData());
    }


export const setFormSubmit = (isSubmit) => ({
    type: SET_FORM_SUBMIT,
    isSubmit
});

export const setServerWorkData = data => ({
    type: SET_SERVER_RATES_DATA,
    data
});

export const setWorkData = data => ({
    type: SET_INFO_DATA,
    data
});

export const setWorkRatesData = (id, data) => ({
    type: SET_RATE_INFO_DATA,
    id,
    data
});

export const clearWorkData = data => ({
    type: CLEAR_INFO_DATA,
    data
});

export const validateWorkRatesInfoData = () => ({
    type: VALIDATE_INFO_DATA,
});

export const setValidate = (set) => ({
    type: SET_VALIDATE,
    set
});

export const setIsValid = (isValid) => ({
    type: IS_VALID,
    isValid
});

const initialState = {
    specilizationIn: [],
    workRates: {},
    validate: false,
    isValid: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_SERVER_RATES_DATA:
            let serverSate = { ...state };
            serverSate.specilizationIn = action.data.specilizationIn;
            serverSate.workRates = action.data.workRates;
            return serverSate;

        case SET_INFO_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });

            newState.workRates = { ...state.workRates };
            if (!newState.specilizationIn || !Array.isArray(newState.specilizationIn) ||
                newState.specilizationIn.length == 0) {
                newState.workRates = {};
            } else {
                let newWorkRates = {};
                newState.specilizationIn.forEach(id => {
                    if (newState.workRates[id]) {
                        newWorkRates[id] = newState.workRates[id];
                    } else {
                        newWorkRates[id] = {};
                    }
                });

                newState.workRates = newWorkRates;
            }

            return newState;
        case SET_RATE_INFO_DATA:
            let newState1 = { ...state };
            newState1.workRates = {};
            if (state.workRates) {
                newState1.workRates = { ...state.workRates };
            }
            newState1.workRates[action.id] = action.data;
            return newState1;
        case CLEAR_INFO_DATA:
            return { ...initialState }
        case VALIDATE_INFO_DATA:
            return { ...state, validate: true }
        case SET_VALIDATE:
            return { ...state, validate: action.set }
        case IS_VALID:
            return { ...state, isValid: action.isValid }
        case SET_FORM_SUBMIT:
            return { ...state, isSubmit: action.isSubmit }

    }

    return state;
}